
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="禁用单元格选择" fileName="disable-selection.md" />
        <demo-block>
        <div><p>默认单元格选择是开启的，你可以通过 <code>cellSelectionOption.enable = false</code> 关闭</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table
        fixed-header
        border-y
        :columns=&quot;columns&quot;
        :table-data=&quot;tableData&quot;
        :cellSelectionOption=&quot;cellSelectionOption&quot;
        rowKeyFieldName=&quot;rowKey&quot;
        :rowStyleOption=&quot;rowStyleOption&quot;
    /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                cellSelectionOption: {
                    // disble cell selection
                    enable: false,
                },
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;&quot;,
                        width: 15,
                        align: &quot;center&quot;,
                        fixed: &quot;left&quot;,
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                    },
                    { field: &quot;name&quot;, key: &quot;name&quot;, title: &quot;Name&quot;, align: &quot;left&quot; },
                    { field: &quot;date&quot;, key: &quot;b&quot;, title: &quot;Date&quot;, align: &quot;left&quot; },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;right&quot;,
                    },
                    { field: &quot;address&quot;, key: &quot;d&quot;, title: &quot;Address&quot; },
                ],
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                        rowKey: 0,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                        rowKey: 1,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                        rowKey: 2,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                        rowKey: 3,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                        rowKey: 4,
                    },
                ],
            };
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"fixed-header":"","border-y":"","columns":_vm.columns,"table-data":_vm.tableData,"cellSelectionOption":_vm.cellSelectionOption,"rowKeyFieldName":"rowKey","rowStyleOption":_vm.rowStyleOption}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                cellSelectionOption: {
                    // disble cell selection
                    enable: false,
                },
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "",
                        width: 15,
                        align: "center",
                        fixed: "left",
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                    },
                    { field: "name", key: "name", title: "Name", align: "left" },
                    { field: "date", key: "b", title: "Date", align: "left" },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        align: "right",
                    },
                    { field: "address", key: "d", title: "Address" },
                ],
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shanghai",
                        rowKey: 0,
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                        rowKey: 1,
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                        rowKey: 2,
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                        rowKey: 3,
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                        rowKey: 4,
                    },
                ],
            };
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  